import React, { useEffect, useState } from 'react'
import { useLocation } from '@reach/router'
import TnC from './tnc'
import TrustpilotLogo from '../images/trustpilot-logo.svg'
import TrustpilotStarRating from '../images/trustpilot-star-rating.svg'
import useScript from '../hooks/useScript'

const Footer = () => {
  const [isPageReady, setisPageReady] = useState(null);
  useEffect(() => {
    setisPageReady(document.readyState)
  }, [])
  const { pathname } = useLocation()
  useScript("https://www.googletagmanager.com/gtm.js?id=GTM-NRM47P", isPageReady)

  return (
    <footer>
      <div className='footer_container'>
        <div className='btmFot'>
          <div className='ct'>
            <div className='lnk sa-trustpilot-blk'>
              <div className='trustMnNwRt'>
                <div className='cheers-txt'>Excellent</div>
                <div className='starTrust'>
                  <img alt='' src={TrustpilotStarRating} />
                </div>
                <div className='custmTxt'>
                  Based on&nbsp;
                  <a
                    href='https://www.trustpilot.com/review/airtkt.com'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <span className='bold-underline'>56,232 reviews</span>
                  </a>
                </div>
                <div>
                  <a
                    href='https://www.trustpilot.com/review/airtkt.com'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img alt='' src={TrustpilotLogo} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='btm-subsc-blk'>
          <div className='sa-btm-subsc'>
            {pathname.replaceAll('/', '') === 'cheapflights' && <TnC />}
            <div className='cpyBg mobile-copywrite-text'>
              Copyright © {new Date().getFullYear()} AirTkt.com All
              rights reserved.
              <br />
              California: CST# 2021684
            </div>
            <div className='clearfix'></div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
